var alignment_default = {
  "alignLeft": "WAdHq",
  "textWrapNowrap": "_1KgpA",
  "alignRight": "vtf9Z",
  "alignCenter": "XIsk7",
  "sizeFullWidth": "tTKO1",
  "renderedInTable": "zrWGU",
  "sizeOriginal": "vqX3I",
  "sizeContent": "_1HFwu",
  "sizeSmall": "HW5kR",
  "sizeSmallCenter": "aoeiy",
  "flex": "Zp4Xi",
  "LEFT": "CJ-tj",
  "CENTER": "s1Rcw",
  "RIGHT": "SjSHx",
  "AUTO": "Npj1E",
  "JUSTIFY": "-NX0r"
};
export {
  alignment_default as default
};
//# sourceMappingURL=alignment-scss.js.map
